import { render } from "./ServiceCoupons.vue?vue&type=template&id=44f7f03c&lang=true"
import script from "./ServiceCoupons.vue?vue&type=script&lang=js"
export * from "./ServiceCoupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__